"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _uiPropTypes = require("@instructure/ui-prop-types");

var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");

var _safeCloneElement = _interopRequireDefault(require("@instructure/ui-utils/lib/react/safeCloneElement"));

var _matchComponentTypes = _interopRequireDefault(require("@instructure/ui-utils/lib/react/matchComponentTypes"));

var _uid = _interopRequireDefault(require("@instructure/uid"));

var _hasVisibleChildren = _interopRequireDefault(require("@instructure/ui-a11y/lib/utils/hasVisibleChildren"));

var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));

var _MenuItem = _interopRequireDefault(require("../MenuItem"));

var _MenuItemSeparator = _interopRequireDefault(require("../MenuItemSeparator"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _dec2, _class, _class2, _temp;

var styles = {
  componentId: 'eoNrR',
  template: function template(theme) {
    return "\n\n.eoNrR_bGBk{display:block}\n\n.eoNrR_JelF{list-style-type:none;margin:0 0 0 0;padding:0}\n\n.eoNrR_blJt{background:".concat(theme.background || 'inherit', ";color:").concat(theme.color || 'inherit', ";display:block;font-family:").concat(theme.fontFamily || 'inherit', ";font-size:").concat(theme.fontSize || 'inherit', ";font-weight:").concat(theme.fontWeight || 'inherit', ";padding:").concat(theme.padding || 'inherit', ";text-align:start}\n\n[dir=ltr] .eoNrR_blJt{text-align:left}\n\n[dir=rtl] .eoNrR_blJt{text-align:right}");
  },
  'root': 'eoNrR_bGBk',
  'items': 'eoNrR_JelF',
  'label': 'eoNrR_blJt'
};
var MenuItemGroup = (
/**
---
parent: Menu
---
**/
_dec = (0, _uiTestable.default)(), _dec2 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(MenuItemGroup, _Component);

  function MenuItemGroup(props) {
    var _this;

    (0, _classCallCheck2.default)(this, MenuItemGroup);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MenuItemGroup).call(this));

    _this.handleSelect = function (e, value, selected, item) {
      if (_this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (_this.props.selected) {
        _this.updateSelected(e, value, _this.props.selected, selected, item);
      } else {
        _this.setState(function (state) {
          return {
            selected: _this.updateSelected(e, value, state.selected, selected, item)
          };
        });
      }
    };

    _this.updateSelected = function (e, value, items, selected, item) {
      var allowMultiple = _this.props.allowMultiple;
      var updated = allowMultiple ? (0, _toConsumableArray2.default)(items) : [];
      var location = updated.indexOf(value);

      if (selected === true && location < 0) {
        updated.push(value);
      } else if (selected === false && location !== -1) {
        updated.splice(location, 1);
      } else if (!allowMultiple && updated.length < 1) {
        // don't allow nothing selected if it's not allowMultiple/checkbox
        updated = (0, _toConsumableArray2.default)(items);
      }

      if (typeof _this.props.onSelect === 'function') {
        _this.props.onSelect(e, updated, selected, item);
      }

      return updated;
    };

    if (typeof props.selected === 'undefined') {
      _this.state = {
        selected: _this.selectedFromChildren(props) || props.defaultSelected
      };
    }

    _this._labelId = (0, _uid.default)('MenuItemGroup');
    return _this;
  }

  (0, _createClass2.default)(MenuItemGroup, [{
    key: "selectedFromChildren",
    value: function selectedFromChildren(props) {
      var children = props.children,
          allowMultiple = props.allowMultiple;
      var selected = [];

      var items = _react.Children.toArray(children).filter(function (child) {
        return (0, _matchComponentTypes.default)(child, [_MenuItem.default]);
      });

      items.forEach(function (item, index) {
        if ((selected.length === 0 || allowMultiple) && (item.props.selected || item.props.defaultSelected)) {
          selected.push(item.props.value || index);
        }
      });
      return selected.length > 0 ? selected : null;
    }
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      var label = this.props.label;
      return (0, _hasVisibleChildren.default)(label) ? _react.default.createElement("span", {
        className: styles.label
      }, label) : label;
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          disabled = _this$props.disabled,
          controls = _this$props.controls,
          allowMultiple = _this$props.allowMultiple,
          isTabbable = _this$props.isTabbable,
          onMouseOver = _this$props.onMouseOver;
      var index = -1;
      return _react.Children.map(children, function (child) {
        if ((0, _matchComponentTypes.default)(child, [_MenuItem.default])) {
          ++index;
          var value = child.props.value || index;
          return _react.default.createElement("li", {
            role: "none"
          }, " ", (0, _safeCloneElement.default)(child, {
            tabIndex: isTabbable && index === 0 ? 0 : -1,
            controls: controls,
            value: value,
            type: allowMultiple ? 'checkbox' : 'radio',
            ref: _this2.props.itemRef,
            disabled: disabled || child.props.disabled,
            selected: _this2.selected.indexOf(value) > -1,
            onSelect: _this2.handleSelect,
            onMouseOver: onMouseOver
          }), " ");
        } else {
          return child;
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var props = (0, _passthroughProps.omitProps)(this.props, MenuItemGroup.propTypes);
      return _react.default.createElement("span", Object.assign({}, props, {
        className: styles.root,
        role: "presentation"
      }), _react.default.createElement("span", {
        id: this._labelId
      }, this.renderLabel()), _react.default.createElement("ul", {
        role: "menu",
        className: styles.items,
        "aria-disabled": this.props.disabled ? 'true' : null,
        "aria-labelledby": this._labelId
      }, this.renderChildren()));
    }
  }, {
    key: "selected",
    get: function get() {
      if (typeof this.props.selected === 'undefined' && typeof this.state.selected === 'undefined') {
        return [];
      } else {
        return typeof this.props.selected === 'undefined' ? (0, _toConsumableArray2.default)(this.state.selected) : (0, _toConsumableArray2.default)(this.props.selected);
      }
    }
  }]);
  MenuItemGroup.displayName = "MenuItemGroup";
  return MenuItemGroup;
}(_react.Component), _class2.propTypes = {
  label: _propTypes.default.node.isRequired,
  allowMultiple: _propTypes.default.bool,

  /**
  * children of type `MenuItem`, `MenuItemSeparator`
  */
  children: _uiPropTypes.Children.oneOf([_MenuItem.default, _MenuItemSeparator.default]),

  /**
  * an array of the values (or indeces by default) for the selected items
  */
  selected: (0, _uiPropTypes.controllable)(_propTypes.default.array, 'onSelect', 'defaultSelected'),

  /**
  * an array of the values (or indeces by default) for the selected items on initial render
  */
  defaultSelected: _propTypes.default.array,

  /**
  * call this function when a menu item is selected
  */
  onSelect: _propTypes.default.func,
  onMouseOver: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,

  /**
  * the id of the element that the menu items will act upon
  */
  controls: _propTypes.default.string,

  /**
  * returns a reference to the `MenuItem`
  */
  itemRef: _propTypes.default.func,
  disabled: _propTypes.default.bool,

  /**
  * should the group appear in the tab order (the first item will have a tabIndex of 0)
  */
  isTabbable: _propTypes.default.bool
}, _class2.defaultProps = {
  onMouseOver: void 0,
  disabled: false,
  controls: void 0,
  onKeyDown: void 0,
  selected: void 0,
  children: null,
  isTabbable: false,
  allowMultiple: false,
  defaultSelected: [],
  itemRef: function itemRef(item) {},
  onSelect: function onSelect(e, value, selected, item) {}
}, _temp)) || _class) || _class);
exports.default = MenuItemGroup;